import React from 'react';
import { Route } from 'react-router-dom';
import PropTypes from 'prop-types';
import loadable from '@loadable/component'
import { Loader } from '../../../../../common/components';

const EditUserAddress = loadable(() => import('./EditUserAddress'), {
    fallback: <Loader/>,
});
const ViewUserAddress = loadable(() => import('./ViewUserAddress'), {
    fallback: <Loader/>,
});
const UserAddressRoutes = ({ t, alert }) => {
  return [
    <Route key="edit_user_address" exact path="/edit/:id" element={<EditUserAddress t={t} alert={alert} />} />,
    <Route
      key="view_user_address"
      exact
      path="/view/:id/address"
      element={<ViewUserAddress t={t} alert={alert} />}
    />
  ];
};
UserAddressRoutes.propTypes = {
  t: PropTypes.func
};
export default UserAddressRoutes;
